<template>
  <span class="changetracker" @mouseover="onMouseHover" @mouseleave="omMouseHoverOff">
    <span class="last-saved-text">{{$t('changetracker.timestamp')}} {{ formatUtcDate(TimeStamp) }}</span>
    <transition name="fade">
    <template v-if="show" v-show="false">
      <div ref="errorMsg" class="alert alert-secondary info-box" role="alert">
        <div class="row">
          <div class="col-md-5 text-right font-weight-bold">{{$t('changetracker.createddateby')}} </div>
          <div class="col-md-7 text-left">{{ `${formatUtcDate(CreateDate)} [${CreatedBy}]` }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 text-right font-weight-bold">{{$t('changetracker.modifiedby')}} </div>
          <div class="col-md-7 text-left">{{ `${formatUtcDate(TimeStamp)} [${ModifiedBy}]` }}</div>
        </div>
      </div>
    </template>
    </transition>
  </span>
</template>

<script>
import Utils from '@/libs/utils.js';
import Popper from 'popper.js';
export default {
  props: ['TimeStamp', 'CreateDate', 'CreatedBy', 'ModifiedBy'],
  data() {
    return {
      show: false,
      hover: false,
      popper: null
    };
  },
  methods: {
    formatUtcDate(date) {
      if (date) return Utils.utcToLocal(date);
    },
    onMouseHover() {
      this.hover = true;
      const self = this;
      setTimeout(() => {
        if (self.hover) self.show = true;
      }, 2000);
    },
    omMouseHoverOff() {
      this.show = false;
      this.hover = false;
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.changetracker {
  display: inline-block;
  padding: 1rem;
  position: relative;
  .last-saved-text {
    color: #95a3b1;
  }
  .info-box {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 500;
    min-width: 300px;
  }
}
</style>
